<template>
  <div v-if="documentFill">
    <h1>Fill document</h1>
    <v-alert :value="true" color="info">
      Edit original
      <router-link
        :to="{ name: 'documentEdit', params: { id: $route.params.id } }"
        >document</router-link
      >
    </v-alert>
    <v-alert :value="true" color="info"
      >You can save the form data at any time by clicking the Save button at the
      bottom. When submitting the completed form you will receive a warning if
      anything is not filled.</v-alert
    >
    <document-element-fill
      :documentElement="documentFill.documentElement"
      :entryItems="documentFill.entryItems"
      :fill="true"
      @updated="updated($event, index)"
    />
    <v-btn @click="saveDocumentFill()"> <v-icon>save</v-icon>Save </v-btn>
    <v-btn @click="submitDocumentFill()"> <v-icon>save</v-icon>Submit </v-btn>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Fill",
  metaInfo() {
    return {
      title: "Fill",
      titleTemplate: "%s - Document - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return {
      documentFill: null
    };
  },
  methods: {
    fetchDocumentFill() {
      nbmlaw
        .get(`/cors/admin/document/documents/${this.$route.params.id}/fill`)
        .then((response) => {
          console.log(response.data);
          this.documentFill = response.data;
        });
    },
    saveDocumentFill() {},
    submitDocumentFill() {}
    // updated(e, index) {}
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.fetchDocumentFill();
      }
    }
  }
};
</script>
